/**
 * The `kubernetes-dashboard` plugin: registers a top-level Kubernetes cluster
 * overview page at `/kubernetes` with a sidebar nav item.
 *
 * The stock kubernetes plugin's standalone `page:kubernetes` is entity-scoped
 * (its Router calls useEntity()) and crashes at the top level — it is disabled in
 * app-config (`app.extensions`). This page replaces it with a real,
 * entity-independent clusters overview. Nav id is `page:kubernetes-dashboard`;
 * title + icon make the AppNav surface it in the sidebar.
 */
import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import React from 'react';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';

export const kubernetesDashboardRouteRef = createRouteRef();

const kubernetesDashboardPage = PageBlueprint.make({
  params: {
    path: '/kubernetes',
    routeRef: kubernetesDashboardRouteRef,
    title: 'Kubernetes',
    icon: React.createElement(DeviceHubIcon),
    loader: () =>
      import('../../pages/KubernetesDashboardPage').then(m =>
        React.createElement(m.KubernetesDashboardPage),
      ),
  },
});

export const kubernetesDashboardPlugin = createFrontendPlugin({
  pluginId: 'kubernetes-dashboard',
  extensions: [kubernetesDashboardPage],
});
